module.exports = __webpack_public_path__ + "img/iphone5_splash.0b64781b.png";